import { ThemeOptions } from '@mui/material'

// OsloMet style guide: https://ansatt.oslomet.no/logo-visuell-profil
// We use #ffd500 as their yellow, even though it differs from the style guide,
// as this is what oslomet.no uses.

const oslometTheme: ThemeOptions = {
  greg: {
    footerBgColor: '#ffdc00',
    footerTextColor: 'black',
    headerBgColor: '#ffdc00',
    headerTextColor: 'black',
    wizardButtonColor: 'black',
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
  },
  palette: {
    primary: {
      main: '#007acc',
      light: '#ffffff',
    },
    secondary: {
      main: '#000000',
      dark: '#595959',
      light: '#9db7e1',
    },
  },
}

export default oslometTheme
